import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import React from 'react';
import Slider from 'react-slick';

import { partnersCarouselSettings } from './partnersCarouselSettings';

const PartnersCarousel = (props: any) => {
  return (
    <div className="home__customer ">
      <div className="container">
        <h2 className="partners-category-title heading-h2 text-center">
          <span className="">
            {props.title} <span className="heading-bold">Partners</span>
          </span>
        </h2>
      </div>
      <div className="home__customer--slider partners--slider slider--new">
        <div className="w-100">
          <Slider {...partnersCarouselSettings}>
            {props.partners.map((partner: any, index: number) => (
              <div className="item forex-item" key={index}>
                <div className="slide-content slide-card">
                  <div className="partner-carousel-card">
                    <div className="partner-img-container">{partner.image}</div>
                    <div className="partner-content">
                      <div>
                        <span className="partner-content-title">
                          {partner.title}
                        </span>
                        <p className="partner-content-p">
                          {partner.description}
                        </p>
                      </div>
                      <a
                        href={'#'}
                        onClick={() => {
                          props.setPartnerInfoCat(props.cat);
                          props.setPartnerInfoIndex(index);
                        }}
                        data-toggle="modal"
                        data-target="#abccc"
                        className="partner-content-viewmore"
                      >
                        View More
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default PartnersCarousel;
